import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ActiveSecurityContextStateService } from '../active-security/active-security-context.state-service';
import { DATE_OF_BIRTH_VERIFICATION_REQUIRED } from '@auth-n/date-of-birth-verification/date-of-birth-verification.service';

@Injectable()
export class DateOfBirthVerificationRequiredInterceptor implements HttpInterceptor {
  constructor(private activeSecurity: ActiveSecurityContextStateService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 403 && error.error === DATE_OF_BIRTH_VERIFICATION_REQUIRED) {
          this.activeSecurity.ensureDateOfBirthVerificationPrompt();
          return EMPTY;
        }
        return throwError(() => error);
      })
    ) as Observable<HttpEvent<any>>;
  }
}
